export const calculateBar = (psi, floatSize = 2, lang = "de-DE") =>
  Number.parseFloat((Number(psi) * 0.0689476)?.toFixed(floatSize))?.toLocaleString(lang);
export const calculatePis = (bar, floatSize = 2, lang = "de-DE") =>
  Number.parseFloat((Number(bar) / 0.0689476)?.toFixed(floatSize))?.toLocaleString(lang);
export const createRowData = (key, value) => ({
  key,
  value,
});

export const createPSIData = () => {
  const d = [];
  [...Array.from({ length: 9 }, (_, i) => i + 1), ...Array.from({ length: 10 }, (_, i) => (i + 1) * 10)].map((el) => {
    d.push(createRowData(el, calculateBar(el)));
  });
  return d;
};

export const createBarData = () => {
  const d = [];
  const values = [0.1, 0.5, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0];
  values.map((el) => {
    d.push(
      createRowData(
        el
          ?.toFixed(1)
          ?.toString()
          .replace(".", ","),
        calculatePis(el)
      )
    );
  });
  return d;
};
